import { activateNavbarBurger } from "../../utils/bulmautil/navbar_burger";
import { pickElement as $ } from "../../utils/pickelements";

import { ConditionArea } from "./conditionarea/conditionarea";
import { MapArea } from "./maparea/maparea";
import { ResultArea } from "./resultarea/resultarea";

(async () => {
    try {
        activateNavbarBurger();

        const conditionArea = new ConditionArea($("#condition_area"));
        const mapArea = new MapArea($("#map_area"));
        const resultArea = new ResultArea($("#result_area"));

        conditionArea.on("update", (results) => {
            mapArea.setSites(results);
            resultArea.setSites(results);
        });

        mapArea.on("selectExtent", (extent) => {
            conditionArea.setExtent(extent);
        });

        await Promise.all([
            conditionArea.init(),
            mapArea.init(),
            resultArea.init()]);

        // 初期データを読み込む
        conditionArea.loadInitialData();
    } catch (e) {
        console.error(e);
        alert((Error.isError(e)) ? e.message : e);
    }
})();
